<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="abrirModal()"
        >
            <span><i class="fa fa-plus mr-2"></i>Adicionar Anexo</span>
        </b-button>

        <b-modal
            id="modalInserirAnexoMedicao"
            v-model="mostrarModal"
            @show="limparForm()"
            no-close-on-backdrop
        >
            <div slot="modal-title">Inserir Anexo</div>

            <b-row class="mt-4">
                <b-col>
                    <b-form-group>
                        <label for="filtro">Tipo Anexo</label>
                        <b-form-select
                            :options="tiposAnexo"
                            v-model="tipoAnexoId"
                            text-field="descricao"
                            value-field="id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <b-form-file
                            ref="selecaoArquivo"
                            :disabled="!tipoAnexoId"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecionar"
                            accept=".jpg,.jpeg,.png,.pdf,.docx"
                            @change="selecionarArquivo"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group v-if="anexo">
                        {{ anexo.nome }} {{ tamanhoArquivoFormatado }}
                    </b-form-group>
                </b-col>
            </b-row>


            <div slot="modal-footer">
                <b-button
                    ref="btnCancelar"
                    variant="secondary"
                    @click="fecharModal($event)"
                >Cancelar</b-button>
                
                <b-button
                    variant="primary"
                    :disabled="!anexo"
                    @click.stop="adicionarAnexo($event)"
                    class="ml-1"
                >Inserir</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

import { tiposAnexo } from './../tiposAnexo.js'

export default {
    data() {
        return {
            mostrarModal: false,
            tiposAnexo: tiposAnexo,
            tipoAnexoId: null,
            anexo: null,
        }
    },

    computed: {

        tamanhoArquivoFormatado() {
            if (this.anexo.tamanho === 0) 
                return '0 Bytes'

            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(this.anexo.tamanho) / Math.log(k))
            
            return parseFloat((this.anexo.tamanho / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        limparForm() {
            this.tipoAnexoId = null
            this.anexo = null
        },

        selecionarArquivo(event) {

            if (event.target.files && event.target.files.length > 0) {

                let arquivoSelecionado = event.target.files[0]
                let tipoAnexoSelecionado = tiposAnexo.find(item => item.id === this.tipoAnexoId)
        
                this.anexo = {
                    nome: arquivoSelecionado.name,
                    arquivo: arquivoSelecionado,
                    tipo: this.tipoAnexoId,
                    tipoDescricao: tipoAnexoSelecionado.descricao,
                    data: new Date().toLocaleDateString(),
                    tamanho: arquivoSelecionado.size
                }

                this.$refs.selecaoArquivo.reset();
            }
            else {
                this.anexo = null
            }

        },

        adicionarAnexo(event) {
            this.fecharModal(event)
            this.$emit('adicionarAnexo', this.anexo)
        },

        fecharModal(event) {
            event.target.blur();
            this.mostrarModal = false
        },
    },
}
</script>